import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon, SmartphoneIcon, WatchIcon, HeadphonesIcon, BatteryChargingIcon, ZapIcon, Gamepad2Icon, MonitorIcon, TagIcon, SparklesIcon } from 'lucide-react';
import { categories } from '../../data/categories';
const iconMap: Record<string, React.ReactNode> = {
  Smartphone: <SmartphoneIcon className="w-5 h-5" data-id="element-419" data-mp="1syemsgqye1qq" />,
  Watch: <WatchIcon className="w-5 h-5" data-id="element-420" data-mp="w972fc22lyoe" />,
  Headphones: <HeadphonesIcon className="w-5 h-5" data-id="element-421" data-mp="wai67bvin6fi" />,
  Battery: <BatteryChargingIcon className="w-5 h-5" data-id="element-422" data-mp="10a94s1raaqul" />,
  Zap: <ZapIcon className="w-5 h-5" data-id="element-423" data-mp="10askrcxdj55z" />,
  Gamepad2: <Gamepad2Icon className="w-5 h-5" data-id="element-424" data-mp="159vdpz02xkxl" />,
  Monitor: <MonitorIcon className="w-5 h-5" data-id="element-425" data-mp="1580tyo0jnyv3" />
};
export function Navigation() {
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  return <nav className="bg-primary-600 text-white sticky top-[72px] z-30" data-id="element-426" data-mp="2gp0uu80yjm0q">
      <div className="max-w-7xl mx-auto px-4" data-id="element-427" data-mp="2gqv3onyyfnog">
        <div className="flex items-center justify-between h-12" data-id="element-428" data-mp="2ln2eov67jpd9">
          {/* Categories dropdown */}
          <div className="relative" data-id="element-429" data-mp="1rs2umwjrte46">
            <button className="flex items-center gap-2 px-4 py-2 bg-primary-700 rounded-lg hover:bg-primary-800 transition-colors" onClick={() => setIsCategoriesOpen(!isCategoriesOpen)} onMouseEnter={() => setIsCategoriesOpen(true)} aria-expanded={isCategoriesOpen} aria-haspopup="true" data-id="element-430" data-mp="1rr062v9x7nrf">
              <span className="font-medium" data-id="element-431" data-mp="1dric81hrpkb7">Categories</span>
              <ChevronDownIcon className={`w-4 h-4 transition-transform ${isCategoriesOpen ? 'rotate-180' : ''}`} data-id="element-432" data-mp="18tgsdecipgyo" />
            </button>

            {isCategoriesOpen && <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-xl shadow-dropdown py-2 z-50" onMouseLeave={() => setIsCategoriesOpen(false)} data-id="element-433" data-mp="1404b5pa64cfy">
                {categories.map(category => <Link key={category.id} to={`/products?category=${category.slug}`} className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors" onClick={() => setIsCategoriesOpen(false)} data-id="element-434" data-mp="v3dcd548ejho">
                    <span className="text-primary-600" data-id="element-435" data-mp="bfqr6gprgu51">
                      {iconMap[category.icon] || <TagIcon className="w-5 h-5" data-id="element-436" data-mp="bi3gxg1rg8sn" />}
                    </span>
                    <span className="font-medium" data-id="element-437" data-mp="gg4zlzv9y63l">{category.name}</span>
                    <span className="ml-auto text-sm text-gray-400" data-id="element-438" data-mp="2g3x6fzd2qm0">
                      {category.productCount}
                    </span>
                  </Link>)}
              </div>}
          </div>

          {/* Main navigation links */}
          <div className="hidden md:flex items-center gap-1" data-id="element-439" data-mp="u8be7his450x">
            <Link to="/products?featured=true" className="flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors" data-id="element-440" data-mp="z4a08ygmxay6">
              <SparklesIcon className="w-4 h-4" data-id="element-441" data-mp="lc3r3wbwg488" />
              <span className="font-medium" data-id="element-442" data-mp="pegpfzobgzuz">Spotlight</span>
            </Link>
            <Link to="/products?deals=true" className="flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors" data-id="element-443" data-mp="1d4kp5vydwfgp">
              <TagIcon className="w-4 h-4" data-id="element-444" data-mp="1hx41yqp8z6kg" />
              <span className="font-medium" data-id="element-445" data-mp="32lybf3gau1nq">Deals</span>
            </Link>
            <Link to="/products?new=true" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-446" data-mp="32jvdzycth68z">
              New Arrivals
            </Link>
            <Link to="/products?bestseller=true" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-447" data-mp="3cbi04pqp0pqi">
              Best Sellers
            </Link>
          </div>

          {/* Right side links */}
          <div className="hidden md:flex items-center gap-1" data-id="element-448" data-mp="2jp6wf67si8ph">
            <Link to="/about" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-449" data-mp="2epu0lvyxxrar">
              About Us
            </Link>
            <Link to="/contact" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-450" data-mp="2olxefz35nedj">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>;
}